
import React, { useState } from 'react'

import { RewardContent, RewardGrid, RewardItem, Ctitle, DescIcon, IconClose } from './style'

import { Toast } from 'antd-mobile'

import {
	getMatchReward
} from '@/api/user-new'

import { Modal } from 'antd-mobile'

const Desc = ({activityId,token}) => {
	const [descVisible, setDescVisible] = useState(false)
	const [season, setSeason] = useState({
		myReward:{
			rank:'',
			awards:[]
		},
		myInvitationReward:{
			rank:'',
			awards:[]
		}
	})
	const [weekList, setWeekList] = useState([{}]);


	const showModal = async () => {
	
		if(!token)  {
			return Toast.info('请先登录')
		}
		const data = await getMatchReward(activityId);

		if(data[0]) {
			setSeason(data[0]);
		}
		setWeekList(data.slice(1))
		setDescVisible(true)
	}

	return (
		<React.Fragment>
			<DescIcon
				src={require('@/img/activity22/0.png')}
				onClick={() => showModal()} >
					我的<br/>奖励
				</DescIcon>
			<Modal 
				visible={descVisible} 
				wrapClassName="rw-desc-modal-outer" className={'lx-desc-modal long-modal'} 
				transparent onClose={() => setDescVisible(false)}>
					<Ctitle>
						<div >我的奖励</div>
					</Ctitle>
					<IconClose onClick={() => setDescVisible(false)} />
					<RewardContent >
						<div className='title'>我的季赛奖励预览</div>
						<RewardGrid>
							<RewardItem className='item'>
								<div className='item_header'>
									<div className='item_header_title'>我的比赛奖励</div>
									<div className='item_header_title_tips'>当前排名：{ season.myReward ? (season.myReward.rank> 200? '200+': (season.myReward.rank||'-')) : '-'}</div>
								</div>
								<div className='item_body'>
									{
										season.myReward && season.myReward.awards && season.myReward.awards.length>0?
										(<div >
											{
											season.myReward.awards.map((it) => {
													return <div className='li' >{it.name}</div>
												})
											}
										</div>)
										:<img className="empty-img" src={require('@/img/activity22/empty.png')} alt="市值风云" />
									}
								</div>
							</RewardItem>
							<RewardItem className='item'>
								<div className='item_header'>
									<div className='item_header_title'>我的邀请奖励</div>
									<div className='item_header_title_tips'>好友当前排名：{ season.myInvitationReward?(season.myInvitationReward.rank> 200? '200+': (season.myInvitationReward.rank ||'-') ) : '-'}</div>
								</div>
								<div className='item_body'>
									{
										season.myInvitationReward && season.myInvitationReward.awards && season.myInvitationReward.awards.length>0?
										(<div >
											{
											season.myInvitationReward.awards.map((it) => {
												return <div className='li' >{it.name}</div>
											})
										}
										</div>)
										:<img className="empty-img" src={require('@/img/activity22/empty.png')} alt="市值风云" />
									}
								</div>
							</RewardItem>
						</RewardGrid>
						<div className='title'>我的周赛奖励预览</div>
						{
							weekList.map(item => {
							
								return (
									<div>
										<div className='title2'>{item.name} {item.timeFrame? `(${item.timeFrame})`:''}</div>
										<RewardGrid>
										<RewardItem className='item'>
											<div className='item_header'>
												<div className='item_header_title'>我的比赛奖励 </div> 
												<div className='item_header_title_tips'>
													当前排名：{ (item.myReward && item.myReward.rank) ? (item.myReward.rank > 200? '200+':(item.myReward.rank||'-')) : '-'}
												</div>
											</div>
											<div className='item_body'>
											{
												item.myReward && item.myReward.awards && item.myReward.awards.length>0?
												(<div>
													{
													item.myReward.awards.map((it) => {
														return <div className='li' >{it.name}</div>
													})
												}
												</div>)
												:<img className="empty-img" src={require('@/img/activity22/empty.png')} alt="市值风云" />
											}
										</div>
									</RewardItem>
									<RewardItem className='item'>
										<div className='item_header'>
											<div className='item_header_title'>我的邀请奖励</div>
											<div className='item_header_title_tips'>
												好友当前排名：{ (item.myInvitationReward && item.myInvitationReward.rank) ? (item.myInvitationReward.rank > 200? '200+':(item.myInvitationReward.rank||'-')) : '-'}
											</div>
										</div>
										<div className='item_body'>
											{
												item.myInvitationReward && item.myInvitationReward.awards && item.myInvitationReward.awards.length>0?
												(<div >
													{
													item.myInvitationReward.awards.map((it) => {
														return <div className='li' >{it.name}</div>
													})
												}
												</div>)
												:<img className="empty-img" src={require('@/img/activity22/empty.png')} alt="市值风云" />
											}
										</div>
									</RewardItem>
								</RewardGrid>
								</div>
								)
							})
						}
						

					</RewardContent>
					{/* <div style={{height: '30px'}}></div> */}
			</Modal>
		</React.Fragment>
	)
}
export default Desc


// WEBPACK FOOTER //
// ./src/views/activity_100/components/reward.js